import { fetchAppSettings } from '@/api/settings';
import { ApiError } from '@/api/core/client';
import { useKeyboardStore } from './keyboardStore';
import { useUIStore } from './uiStore';
import { useCalendarStore } from './calendarStore';

let loadPromise: Promise<void> | null = null;

export function loadAppSettings(): Promise<void> {
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = (async () => {
    try {
      const settings = await fetchAppSettings();
      useKeyboardStore.getState().applyServerSettings(settings.keyboardShortcuts);
      useUIStore.getState().hydrateSearchMode(settings.searchMode);
      useUIStore.getState().hydrateLabelsVisible(settings.labelsVisible);
      // Hydrate calendar default - backend setting takes precedence over localStorage
      if (settings.defaultCreateCalendarUid !== null) {
        useCalendarStore.getState().setDefaultCreateCalendar(settings.defaultCreateCalendarUid);
      }
    } catch (error) {
      if (error instanceof ApiError && (error.status === 401 || error.status === 403)) {
        return;
      }
      console.error('Failed to load app settings', error);
    } finally {
      loadPromise = null;
    }
  })();

  return loadPromise;
}
